import moment from 'moment'
import BigNumber from 'bignumber.js'
import { KNOT_PER_MS } from './constants'

export const BasicDataUnits = {
  MS: 'm/s',
  KNOT: 'knot',
} as const

export type BasicDataUnit = (typeof BasicDataUnits)[keyof typeof BasicDataUnits]

export const converteWindUnit = (value: number | undefined, unit: BasicDataUnit): number | BigNumber | undefined => {
  if (value === undefined) {
    return undefined
  }

  if (!value) {
    return 0
  }

  if (unit === BasicDataUnits.MS) {
    return value
  }

  return KNOT_PER_MS.times(value)
}

export const formatStatusTime = (datetime: string, resolution: string) => {
  const mDate = moment(datetime)
  let placeholder = 'YYYY-MM-DD'

  if (['minute', 'hour', 'day'].includes(resolution)) {
    placeholder = 'HH:mm'
  } else if (resolution === 'month') {
    placeholder = 'D日'
  }

  const formatted = mDate.format(placeholder)
  return formatted === '00:00' ? '24:00' : formatted
}

export const format = (datetime: string, formatStr: string) => {
  if (!datetime) {
    return ''
  }

  return moment(datetime).format(formatStr)
}

export const fixDecimal = (target: number): string => {
  return target !== undefined ? target.toFixed(1) : ''
}

export const rangeToISO = (range: Range) => {
  return {
    startTime: moment(range.startTime).toISOString(),
    endTime: moment(range.endTime).toISOString(),
  }
}

export const renderValue = (value?: number, decimal?: number) => {
  if (value === undefined || value === null) {
    return '-'
  }

  return value.toFixed(decimal)
}
